export default __webpack_public_path__ + "static/media/dashboard_pcd.4e42f264.svg";